import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyAffectedFloodReportForm from "./DailyAffectedFloodReportForm";
import "../ReportEnhanced.css";

const DailyAffectedFloodReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Form 1 - Daily Report" />
      </div>
      <div className="report-table-enhanced">
        <DailyAffectedFloodReportForm />
      </div>
    </div>
  );
};

export default DailyAffectedFloodReport;
